import { ILog } from '../../../global/types';
import { IServerResponse } from '../../../global/interfaces/server_response';
import { ErrorsDict, IFormErrorService } from '../../../global/services/form_error_service/form_error_service';
import { ICommand } from 'core-ts-types';
import { Validation } from '../../components/password_validation_popover/password_validation_popover';
import { AccountDatasource } from '../../datasources/account_datasource';

export class ResetPasswordController {
  public password: string;
  public passwordValidations: Validation;
  private errors: ErrorsDict;
  constructor(
    private $state: ng.ui.IStateService,
    private $timeout: ng.ITimeoutService,
    private log: ILog,
    private resetPasswordCommand: ICommand,
    private validatePasswordCommand: ICommand,
    private clearTransferDatasourcesCommand: ICommand,
    private loadTransferStudentCommand: ICommand,
    private phxPasswordValidationPopoverDelegate: any,
    private ngAccountDatasource: AccountDatasource,
    private formErrorService: IFormErrorService
  ) {
    this.onPasswordChange();
  }

  onPasswordChange(): void {
    this.$timeout(() => {
      this.validatePasswordCommand(this.password || '').then((res) => {
        this.passwordValidations = res;
      });
    });
  }

  setNewPassword(): void {
    this.errors = {};
    this.resetPasswordCommand(this.password, this.$state.params['resetPasswordCode'])
      .then(() => {
        return this.clearTransferDatasourcesCommand();
      })
      .then(() => {
        this.log.user.success({
          content: 'Your password has been reset.',
          timeout: 10000,
          dismissOnTimeout: true,
          dismissButton: true
        });
        this.$state.transitionTo('landing', {}, { reload: true });
      })
      .catch((res: ng.IHttpPromiseCallbackArg<IServerResponse>) => {
        this.errors = this.formErrorService(res.data!.error);
      });
  }
}

angular.module('capability-ng-user-app').controller('ngResetPasswordController', ResetPasswordController);



// WEBPACK FOOTER //
// ./app/lib/user_app/views/reset_password/reset_password.ts